import {
  USER_LOGIN,
  USER_LOGOUT,
  USER_FETCH,
  USER_UPDATE,
  USER_INFO,
} from '../mutation-types';

import store from 'store';

const EXPIRE_TIME = 24 * 60 * 60 * 1000;

/* Store Expiration Methods */
var storeWithExpiration = {
  set (key, val, exp) {
    store.set(key, { val: val, exp: exp, time: new Date().getTime() });
  },
  get (key) {
    var info = store.get(key);
    if (!info) { return null; }
    if (new Date().getTime() - info.time > info.exp) { return null; }
    return info.val;
  },
};

const state = {
  userid: null,
  session: null,
  username: null,
  avatar: null,
  authority: null,
};

var Store = {
  set () {
    for (var key in state) {
      if (!state.hasOwnProperty(key)) continue;
      storeWithExpiration.set(key, state[key], EXPIRE_TIME);
    }
  },
  get () {
    var _state = {};
    for (var key in state) {
      if (!state.hasOwnProperty(key)) continue;
      // if (!storeWithExpiration.get(key)) continue;
      _state[key] = storeWithExpiration.get(key);
    }
    return _state;
  },
  clear () {
    for (var key in state) {
      if (!state.hasOwnProperty(key)) continue;
      store.remove(key);
    }
  },
};

import VuexStore from '../store';

const mutations = {
  [USER_LOGIN] (state, info) {
    state = Object.assign(state, info);
    Store.set();
  },
  [USER_LOGOUT] (state) {
    for (const key in state) {
      if (!state.hasOwnProperty(key)) continue;
      state[key] = null;
    }
    Store.clear();
  },
  [USER_FETCH] (state) {
    var info = Store.get();
    state.userid = info.userid;
    state.session = info.session;
    VuexStore.dispatch('SOCKET_REGISTER', info.userid, info.session);
  },
  [USER_UPDATE] () {
    Store.set();
  },
  [USER_INFO] (state, info) {
    state.username = info.username;
    state.avatar = info.avatar;
    state.authority = info.authority;
  },
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js